import { Github } from "styled-icons/boxicons-logos/Github"

const Icons = {
  Github
}

export default Icons
